// extracted by mini-css-extract-plugin
export default {"modal_outside":"Modal_modal_outside__dntYC","modal":"Modal_modal__DJDMv"};